import { Link } from 'react-router';
import { Tag, Dot } from '@/components/Tag';
import { activeState, settlementText } from './status';
import type { Customer, Supplier } from './types';
import s from './Cards.module.css';

function Missing({ label }: { label: string }) {
  return <span className={s.miss}>{label}</span>;
}

/** 客户卡：名称（+ 停用）/ 联系人 · 电话 / 地址 / 归属业务员 + 结算方式 */
export function CustomerCard({ c, to, selected }: { c: Customer; to: string; selected?: boolean }) {
  const st = activeState(c.isActive);
  const stl = settlementText(c);
  return (
    <Link to={to} className={[s.card, selected && s.sel].filter(Boolean).join(' ')}>
      <div className={s.h}>
        <b>{c.name}</b>
        {st && <Tag tone={st.tone} sm>{st.label}</Tag>}
      </div>
      <div className={s.l}>
        {c.contact || <Missing label="缺联系人" />}
        <i>·</i>
        {c.phone ? <span className="tnum">{c.phone}</span> : <Missing label="缺电话" />}
      </div>
      <div className={s.a}>{c.address || <Missing label="缺地址" />}</div>
      <div className={s.f}>
        <span><i>归属</i>{c.ownerUser?.name || <span className="em">未分配</span>}</span>
        <Dot tone={stl.dot}>{stl.label}</Dot>
      </div>
    </Link>
  );
}

/** 供应商卡：名称（+ 停用）/ 编号 · 类型 / 联系人 · 电话 / 结算方式 */
export function SupplierCard({ v, to, selected }: { v: Supplier; to: string; selected?: boolean }) {
  const st = activeState(v.isActive);
  const stl = settlementText(v);
  return (
    <Link to={to} className={[s.card, selected && s.sel].filter(Boolean).join(' ')}>
      <div className={s.h}>
        <b>{v.name}</b>
        {st && <Tag tone={st.tone} sm>{st.label}</Tag>}
      </div>
      <div className={s.sub}><span className="tnum">{v.code || '无编号'}</span>{v.supplierType && <> · {v.supplierType}</>}</div>
      <div className={s.l}>
        {v.contact || <span className="em">未填联系人</span>}
        {v.phone && <><i>·</i><span className="tnum">{v.phone}</span></>}
      </div>
      <div className={s.f}>
        <Dot tone={stl.dot}>{stl.label}</Dot>
        {v.note && <span className={s.note}>{v.note}</span>}
      </div>
    </Link>
  );
}
